import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import appUtils from 'src/components/appUtils';
import {
  usePulseReviewsDue,
  submitPulseReviewDueQuery
} from 'src/queries/pulse';
import { useCompany } from 'src/queries/company';
import { toast } from 'src/components';
import PulseReviewForm from 'src/containers/PulseReviewForm/PulseReviewForm';
import PULSE_CONSTANTS from 'common/pulseConstants';
import commonPulseUtils from 'common/commonPulseUtils';

const PulseReviewsDue = () => {
  const navigate = useNavigate();

  const {
    pulseReviews,
    isFetching: isFetchingPulseReviewsDue,
    isError: isErrorPulseReviewsDue,
    refetch: refetchPulseReviewsDue
  } = usePulseReviewsDue();
  const {
    data: company,
    isFetching: isFetchingCompany,
    isError: isErrorCompany
  } = useCompany();
  const {
    mutateAsync: submitPulseReview,
    isLoading: submitPulseReviewLoading
  } = submitPulseReviewDueQuery();

  const isFetching = isFetchingCompany || isFetchingPulseReviewsDue || submitPulseReviewLoading;
  const isError = isErrorCompany || isErrorPulseReviewsDue;
  const isReady = company && company.id && !isFetching && !isError;

  const pulseReview = pulseReviews[0];

  useEffect(() => {
    if (!isFetching && !pulseReviews.length) {
      toast.show('No pulse reviews to complete.');
      navigate(appUtils.getHomeRoute());
    }
  }, [isFetching, pulseReviews]);

  if (!isReady) return null;

  const {
    questionText, questionChoices, questionAnonymity, questionType
  } = pulseReview;

  const submit = async (values) => {
    const { comments, choice, anonymous } = values;
    const isFreeTextAnswerType = questionType === PULSE_CONSTANTS.TYPES.FREE;
    const data = {
      pulseId: pulseReview.id,
      answer: isFreeTextAnswerType ? null : choice.label,
      score: isFreeTextAnswerType ? null : choice.score,
      comments,
      anonymous: commonPulseUtils.getAnonymous(
        questionAnonymity,
        anonymous.value
      ),
      companyid: company.id
    };
    const result = await submitPulseReview(data);

    if (!result || !result.success) {
      toast.error('Uh oh, we ran into an issue. Please try again later!');
    }
    toast.show('Answer submitted');

    const {
      data: { pulseReviews: newPulseReviews }
    } = await refetchPulseReviewsDue();
    if (!newPulseReviews.length) {
      toast.show('You have completed all pulse reviews!');
      navigate(appUtils.getHomeRoute());
    }
  };

  const pulseReviewsLength = pulseReviews.length;

  return (
    <PulseReviewForm
      onSubmit={submit}
      headerOvertitle={
        pulseReviewsLength > 1
          ? `Pulse Reviews Due: ${pulseReviewsLength} left`
          : 'Pulse Review Due'
      }
      questionText={questionText}
      questionType={questionType}
      questionChoices={questionChoices}
      questionAnonymity={questionAnonymity}
      isLoading={isFetching}
    />
  );
};

export default PulseReviewsDue;
